import React from 'react'
import { Row, Col, Card, CardBody, CardTitle, CardText, Form, Row as FormRow, Col as FormCol, Label, Input, Button } from 'reactstrap'
import PageWrap from 'components/PageWrap'

const ContactPage = () => (
  <PageWrap title="Contact us">
    <Row>
      <Col lg="6">
        <Form className="shadow-sm p-4 rounded-4 border">
          <Row className="g-3">
            <Col md="6">
              <Label className="form-label">First name</Label>
              <Input placeholder="Jane" />
            </Col>
            <Col md="6">
              <Label className="form-label">Last name</Label>
              <Input placeholder="Doe" />
            </Col>
            <Col md="12">
              <Label className="form-label">Email</Label>
              <Input type="email" placeholder="jane@company.com" />
            </Col>
            <Col md="12">
              <Label className="form-label">Message</Label>
              <Input type="textarea" rows="5" placeholder="Tell us about your lab and samples…" />
            </Col>
          </Row>
          <Button color="primary" className="rounded-pill mt-3">Send</Button>
        </Form>
      </Col>
      <Col lg="6" className="mt-4 mt-lg-0">
        <Card className="border-0 shadow-sm h-100">
          <CardBody>
            <CardTitle tag="h5">Head Office</CardTitle>
            <CardText className="text-muted mb-1">4551 Zimmerman Ave.</CardText>
            <CardText className="text-muted mb-1">Niagara Falls, ON L2E 3M5, Canada</CardText>
            <CardText className="text-muted mb-0">+1 (833) 423-0512 · info@coldblock.ca</CardText>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </PageWrap>
)

export default ContactPage